export const addresses = {
  tokenGate: "0x5C8d7748bF07709D3adC3f74fa0255F9f358C8b1",
};
